import { Component, Input, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { GlobalBookingFlight } from '@fcom/common/store';
import { Location, LocationSuggestions } from '@fcom/core-api';
import { ElementActions, ElementTypes, GaContext, GlobalBookingTripDates, TripType } from '@fcom/common';
import { ButtonTheme, IconButtonSize, IconButtonTheme } from '@fcom/ui-components';
import { GtmService } from '@fcom/common/gtm';
import { PriceCalendarType } from '@fcom/common/components/price-calendar/price-calendar.component';

import { LocationParam } from '../../interfaces';
import { BookingWidgetService } from '../../services/booking-widget.service';
import { BookingWidgetFlightService } from '../../services/booking-widget-flight.service';

@Component({
  selector: 'fin-multicity-selector',
  templateUrl: './multicity-selector.component.html',
  styleUrls: ['./multicity-selector.component.scss'],
  standalone: false,
})
export class MulticitySelectorComponent implements OnInit {
  private bookingWidgetService = inject(BookingWidgetService);
  private bookingWidgetFlightService = inject(BookingWidgetFlightService);
  private gtmService = inject(GtmService);

  @Input() enableMultiCity = false;

  readonly ButtonTheme = ButtonTheme;
  readonly IconButtonTheme = IconButtonTheme;
  readonly IconButtonSize = IconButtonSize;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly PriceCalendarType = PriceCalendarType;
  readonly TripType = TripType;

  flights$: Observable<GlobalBookingFlight[]>;

  suggestedLocations$: Observable<LocationSuggestions>;

  trendingDestinations$: Observable<Location[]>;

  ngOnInit(): void {
    this.flights$ = this.bookingWidgetFlightService.flights$;
    this.suggestedLocations$ = this.bookingWidgetFlightService.suggestedLocations$;
    this.trendingDestinations$ = this.bookingWidgetFlightService.trendingDestinations$;
  }

  setLocations({ locations }: LocationParam, index?: number): void {
    this.bookingWidgetFlightService.setLocations(locations, index);
  }

  locationsHaveChanged(index: number): number {
    return index;
  }

  setTravelDates(dates: GlobalBookingTripDates, index: number, isAirCalendar = false, enableMultiCity: boolean): void {
    if (enableMultiCity) {
      this.bookingWidgetService.setTravelDates(dates, index, isAirCalendar, false);
    } else {
      //TODO: remove when new multicity release to all
      // update dates separately to fullfill the multi-city flight structure
      this.bookingWidgetService.setTravelDates({ departureDate: dates.departureDate }, 0, isAirCalendar, false);
      this.bookingWidgetService.setTravelDates({ departureDate: dates.returnDate }, 1, isAirCalendar, false);
    }
  }

  setFlexibleDates(isFlexibleDates: boolean): void {
    this.bookingWidgetService.setFlexibleDates(isFlexibleDates);
  }

  addFlight(index: number): void {
    this.bookingWidgetFlightService.addFlight();
    this.gtmService.trackElement(
      'multicity-add-bound',
      GaContext.BOOKING_FLOW,
      ElementTypes.BUTTON,
      String(index),
      ElementActions.CLICK
    );
  }

  removeFlight(index: number): void {
    this.bookingWidgetFlightService.removeFlight(index);
    this.gtmService.trackElement(
      'multicity-remove-bound',
      GaContext.BOOKING_FLOW,
      ElementTypes.BUTTON,
      String(index + 1),
      ElementActions.CLICK
    );
  }
}
